import * as actionTypes from '../types/contracts';

const initialState = {
  error: false,
  loading: false,
  contractsByStock: [],
  contractUpdate: {
    okRequest: false,
    loading: false
  },
  contractDelete: {
    okRequest: false,
    loading: false
  },
  contractAdd: {
    okRequest: false,
    loading: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_CONTRACTS_BY_STOCK:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_CONTRACTS_BY_STOCK_SUCCESS:
      return {
        ...state,
        contractsByStock: payload,
        loading: false
      };
    case actionTypes.GET_CONTRACTS_BY_STOCK_FAIL:
      return {
        ...state,
        contractsByStock: [],
        loading: false,
        error: payload
      };
    case actionTypes.DELETE_CONTRACT:
      return {
        ...state,
        contractDelete: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.DELETE_CONTRACT_SUCCESS:
      return {
        ...state,
        contractDelete: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.DELETE_CONTRACT_FAIL:
      return {
        ...state,
        contractDelete: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.ADD_CONTRACT:
      return {
        ...state,
        contractAdd: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.ADD_CONTRACT_SUCCESS:
      return {
        ...state,
        contractAdd: {
          okRequest: true,
          loading: false
        }
      };
    case actionTypes.ADD_CONTRACT_FAIL:
      return {
        ...state,
        contractAdd: {
          okRequest: false,
          loading: false
        }
      };
    case actionTypes.UPDATE_CONTRACT:
      return {
        ...state,
        contractUpdate: {
          okRequest: false,
          loading: true
        }
      };
    case actionTypes.UPDATE_CONTRACT_SUCCESS:
      return {
        ...state,
        contractUpdate: {
          okRequest: true,
          loading: false
        }
      };
    case actionTypes.UPDATE_CONTRACT_FAIL:
      return {
        ...state,
        contractUpdate: {
          okRequest: false,
          loading: false
        }
    }
    default:
      return state;
  }
};

export default reducer;
